import { FormattedMessage, useIntl } from "react-intl";
import { Fieldset, Form } from "./SignupStyles";
import InputModule from "@/components/FormElements/InputModule.jsx";
import Button from "@/components/ui/Button.jsx";
import CSRFInput from "@/components/CSRFInput.jsx";
import ConfigService from "@/components/service/ConfigService.js";
import { useState } from "react";

function OttRequest() {
  const intl = useIntl();
  const configService = ConfigService.getInstance();

  const [html5error, setHtml5error] = useState({});

  const checkIsValid = (e) => {
    if (e.target.checkValidity() === false) {
      e.target.parentNode.classList.add("was-validated");
    }
  };

  return (
    <div className="600:w-[360px] mx-auto mt-12 flex flex-col pb-12 px-4">
      <Form
        action={`${configService.formulateContextPath("/ott/generate")}`}
        noValidate
        id="ott-form"
        method="post"
      >
        <Fieldset>
          <h2>
            <FormattedMessage
              id="auth.ottTitle"
              defaultMessage="Request a One-Time Token"
            />
          </h2>
          <div className="relative">
            <InputModule
              type="email"
              placeholder={intl.formatMessage({
                id: "template.email",
                defaultMessage: "Email",
              })}
              identifier="username"
              name="username"
              onBlur={checkIsValid}
              required
              onInvalid={() => {
                let email = {
                  id: "template.email_invalid_message",
                  defaultMessage: "Please enter a valid email address",
                  name: "username",
                };
                setHtml5error((prevState) => ({
                  ...prevState,
                  email,
                }));
              }}
              error={html5error?.email}
              autoComplete="email"
            />
          </div>

          <Button form="ott-form" type="submit" className="mb-3 w-full">
            <FormattedMessage id="auth.ottSend" defaultMessage="Send Token" />
          </Button>
        </Fieldset>
        <CSRFInput />
      </Form>
    </div>
  );
}

export default OttRequest;
